import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

//per impostare la data locale italiana con relativi giorni e mesi
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

registerLocaleData(localeIt);


@Component({
  selector: 'app-card-files',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimelineComponent implements OnInit {
  private _data: any[] | undefined;
  title: string = '';
  type: string = '';

  constructor(
    private cdr: ChangeDetectorRef
  ) {
  }

  @Input() set data(value: any[]) {
    this._data = value;
    this.cdr.markForCheck(); //this.cdr.detectChanges();
  };
  get data(): any[] {
    //console.log(this._data)
    return <any[]>this._data;
  }

  ngOnInit(): void {}

}
